import React, { ReactNode, ReactElement, lazy, Suspense, isValidElement } from "react";
import { createSvgIcon as muiCreateSvgIcon, SvgIcon } from "@mui/material";

// When icons pass a full <svg> element, extract its children and viewBox
// so MUI's SvgIcon renders correctly without nested <svg> elements.
function unwrapSvg(node: ReactNode): { content: ReactNode; viewBox?: string } {
  if (
    isValidElement(node) &&
    typeof node.type === "string" &&
    node.type === "svg"
  ) {
    const props = node.props as { viewBox?: string; children?: ReactNode };
    return { content: props.children, viewBox: props.viewBox };
  }
  return { content: node };
}

export const createSvgIcon = (path: ReactNode, displayName: string) => {
  const { content, viewBox } = unwrapSvg(path);

  const Lazy = lazy(async () => {
    const comp = await Promise.resolve(
      muiCreateSvgIcon(content, displayName)
    );
    return { default: comp as typeof SvgIcon };
  });

  const Wrapper = (props: any) => (
    <Suspense fallback={null}>
      <Lazy viewBox={viewBox || "0 0 24 24"} {...props} />
    </Suspense>
  );

  return Wrapper as unknown as typeof SvgIcon;
};
